import React from "react";
import Button from "@mui/material/Button";
import { Typography } from "@mui/material";

export default function LoginButton() {
  return (
    <Button
      type="submit"
      variant="contained"
      fullWidth
      sx={{
        maxWidth: 300,
        borderRadius: "25px",
        bgcolor: "#29355a",
        "&:hover": {
          bgcolor: "#1f2947",
        },
        py: "15px",
      }}
    >
      <Typography sx={{ fontSize: 15 }} textTransform="none" fontWeight="bold">
        Sign in
      </Typography>
    </Button>
  );
}